<template>
    <div class="container">
        <div class="content-box">
          <div class="element-wrapper pb-0">
            <h3 class="element-header">Planos</h3>
            <div class="element-box">
                <h5 class="form-header">Gerenciar Planos</h5>
                <div class="form-desc" style="margin-botton: 0;">Realize o cadastro, edição, ativação e inativação de planos.</div>
            </div>
          </div>
          
              <div class="element-wrapper">
                <div class="element-actions">
                  <a class="btn btn-warning" @click="novo">
                    <i class="fa fa-file"></i> <span>Novo</span>
                  </a>
                </div>
                <div class="element-box-tp">
                <div class="table-responsive">
                    <table class="table table-padded">
                      <thead>
                          <tr>
                            <th class="text-center">Nome</th>
                            <th class="text-center">Recorrência</th>
                            <th class="text-center">Venda</th>
                            <th class="text-center"></th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="plano in planos" :key="plano._id">
                            <td>
                              <div class="user-with-avatar">
                                <img v-if="plano.drachei" alt="Disponível Dr.Achei" title="Disponível Dr.Achei" :src="require('@/img/brand-drachei-big.svg')">
                                <span>{{plano.name}}</span>
                              </div>
                            </td>
                            <td>
                              {{plano.tipoRecorrencia}}
                            </td>
                            <td class="text-center">
                              <span :class="{'green': plano.publicado, 'red': plano.publicado == false}" class="status-pill smaller"></span>
                            </td>
                            <td class="row-actions text-center">
                                <a @click="edit(plano)" style="cursor: pointer;" title="Editar">
                                  <i class="fa fa-edit"></i>
                                </a>
                            </td>
                          </tr>
                      </tbody>
                    </table>
                </div>
                </div>
            </div>
          </div>

      <!-- Modal -->
      <div class="modal fade" id="modalPlano" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Plano</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="name">Nome</label>
                    <input id="name" name="name" 
                      v-model="plano.name"
                      type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="price">Preço (R$)</label>
                    <money required v-model="plano.price" name="price" class="form-control" id="price"  />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="custom-control custom-checkbox">
                    <input v-model="plano.drachei" type="checkbox" class="custom-control-input" id="customCheck1">
                    <label class="custom-control-label" for="customCheck1">Disponível no Dr.Achei?</label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input v-model="plano.publicado" type="checkbox" class="custom-control-input" id="publicado">
                    <label class="custom-control-label" for="publicado">Disponível para venda?</label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Tipo de Recorrência</label>
                    <select v-model="plano.tipoRecorrencia" class="custom-select">
                      <option :value="null">Selecione</option>
                      <option value="Mensal">Mensal</option>
                      <option value="Anual">Anual</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Id Plano ZOOP</label>
                    <input v-model="plano.idPlanoZoop" type="text" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="">Link Saiba Mais</label>
                    <input v-model="plano.linkSaibaMais" type="text" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <fieldset>
                    <legend>Benefícios</legend>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="">Descrição</label>
                          <div class="input-group">
                            <input type="text" class="form-control" placeholder="Informe a descrição do benefício"
                              v-model="descricaoBeneficio" 
                              aria-label="Recipient's username" aria-describedby="basic-addon2">
                            <div class="input-group-append">
                              <button @click="addBeneficio" class="btn btn-outline-secondary" type="button"><i class="fa fa-plus"></i></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <table class="table">
                        <tbody>
                          <tr v-for="(beneficio, i) in plano.beneficios" :key="beneficio">
                            <td style="width: 80%" v-html="beneficio">
                            </td>
                            <td>
                              <a @click="editarBeneficio(i)" style="cursor: pointer;" class="danger" title="Editar">
                                <i class="fa fa-edit"></i>
                              </a>
                              <a @click="removerBeneficio(i)" style="cursor: pointer;" class="danger" title="Excluir">
                                <i class="fa fa-trash"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </fieldset>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <fieldset>
                    <legend>Outros Benefícios</legend>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="">Descrição</label>
                          <div class="input-group">
                            <input type="text" class="form-control" placeholder="Informe a descrição do benefício"
                              v-model="descricaoOutroBeneficio" 
                              aria-label="Recipient's username" aria-describedby="basic-addon2">
                            <div class="input-group-append">
                              <button @click="addOutroBeneficio" class="btn btn-outline-secondary" type="button"><i class="fa fa-plus"></i></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <table class="table">
                        <tbody>
                          <tr v-for="(outroBeneficio, t) in plano.outrosBeneficios" :key="outroBeneficio">
                            <td style="width: 80%">
                              {{outroBeneficio}}
                            </td>
                            <td>
                              <a @click="removerOutroBeneficio(t)" style="cursor: pointer;" class="danger" title="Excluir">
                                <i class="fa fa-trash"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </fieldset>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
              <button @click="persist" type="button" class="btn btn-primary">Salvar</button>
            </div>
          </div>
        </div>
      </div>
    
    </div>
</template>
<script>
import * as http from 'axios'
export default {
  data () {
    return {
      planos: [],
      plano: {},
      descricaoBeneficio: null,
      descricaoOutroBeneficio: null,
      index: null
    }
  },
  async created () {
    try {
      const response = await http.get('/planos?orderBy=publicado')
      this.planos = response.data
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    novo () {
      this.plano = {}
      this.$nextTick(() => {
        this.$validator.reset()
        window.jQuery('#modalPlano').modal('show')
      })
    },
    edit (plano) {
      this.plano = plano
      this.$nextTick(() => {
        this.$validator.reset()
        window.jQuery('#modalPlano').modal('show')
      })
    },
    addBeneficio () {
      if (this.descricaoBeneficio) {
        if (this.index) {
          this.plano.beneficios[this.index] = this.descricaoBeneficio
          this.index = null
          this.descricaoBeneficio = null
          return false
        }

        if (!this.plano.beneficios) {
          this.plano.beneficios = []
        }
        this.plano.beneficios.push(this.descricaoBeneficio)
        this.descricaoBeneficio = null
      }
    },
    removerBeneficio (index) {
      this.plano.beneficios.splice(index, 1)
    },
    addOutroBeneficio () {
      if (this.descricaoOutroBeneficio) {
        if (!this.plano.outrosBeneficios) {
          this.plano.outrosBeneficios = []
        }
        this.plano.outrosBeneficios.push(this.descricaoOutroBeneficio)
        this.descricaoOutroBeneficio = null
      }
    },
    removerOutroBeneficio (index) {
      this.plano.outrosBeneficios.splice(index, 1)
    },

    editarBeneficio (index) {
      this.index = index
      this.descricaoBeneficio = this.plano.beneficios[index]
    },

    async persist () {
      try {
        if (this.plano._id) {
          await http.put('/planos/' + this.plano._id, this.plano)
        } else {
          await http.post('/planos', this.plano)
        }
        this.$nextTick(() => {
          window.jQuery('#modalPlano').modal('hide')
        })
      } catch (error) {
        console.log(error)
      } finally {
        const response = await http.get('/planos?sort=publicado')
        this.planos = response.data
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/planos/Planos.vue